import { configureStore } from "@reduxjs/toolkit";
import cartReducer from "./cart";
import orderReducer from "./order";
import userReducer from "./user";

export const store = configureStore({
  reducer: {
    cart: cartReducer,
    order: orderReducer,
    user: userReducer,
  },
});
